import { sessionEnded } from "./index";
import { SHOW_NOTIFICATION } from "../types";

export default (e, message, dispatch) => {
  return;
  if (e.message === "Request failed with status code 401") {
    dispatch(sessionEnded());
  } else {
    dispatch({
      type: SHOW_NOTIFICATION,
      payload: { message, type: "error" },
    });
  }
};
